// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37218":"c088b052","65950":"92215e40","81683":"3067c43c"}[chunkId] + ".chunk.css";
};